import React from 'react';
import { File, FileImage, FileVideo, FileAudio } from 'lucide-react';

function FileIcon({ type, className = 'h-4 w-4 text-muted-foreground' }) {
  if (!type || !type.match) return null;

  const Icon = (() => {
    if (type.match('image.*')) return FileImage;
    if (type.match('video.*')) return FileVideo;
    if (type.match('audio.*')) return FileAudio;
    return File;
  })();

  return <Icon aria-hidden="true" strokeWidth={1.75} className={className} />;
}

export default FileIcon;
